export function verifyRunState(run: any, runId: string, state: 'failed' | 'success', actionId?: string): void {
  const expected = state === 'success' ? 'completed' : 'failed';
  const target = actionId
    ? run?.actions?.find((action: any) => String(action._id) === actionId)
    : run;
  if (String(run?._id) !== runId || target?.status !== expected) {
    throw new Error(`The server did not save the requested ${state} state. Refresh and try again.`);
  }
}

/** Ignore older GET/socket snapshots arriving after a successful manual update. */
export function keepLatestRun<T extends { _id: string; updated_at?: string }>(current: T, incoming: T): T {
  if (current._id !== incoming._id) return incoming;
  const currentTime = Date.parse(current.updated_at || '');
  const incomingTime = Date.parse(incoming.updated_at || '');
  return Number.isFinite(currentTime) && Number.isFinite(incomingTime) && currentTime > incomingTime
    ? current
    : incoming;
}
